import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { ReadStatusValidationSchema } from './readStatus';
import { UUIDValidationSchema } from './uuid';
// BaseCommentValidationSchema definition
const BaseCommentValidationSchema = z.object({
    _id: z
        .string()
        .uuid()
        .default(() => uuidv4()),
    workshopId: UUIDValidationSchema,
    coordinates: z.array(z.number()).length(2).optional(),
    createdBy: UUIDValidationSchema,
    body: z
        .string()
        .max(65535, 'Body must be 65535 characters or fewer')
        .optional(),
    created: z.date().default(() => new Date()),
    updated: z
        .date()
        .default(() => new Date())
        .optional(),
    name: z.string().optional(),
    initials: z.string().optional(),
    readStatus: z.array(ReadStatusValidationSchema).default([]),
    parentCommentId: UUIDValidationSchema.optional(),
    attachments: z.array(UUIDValidationSchema).optional()
});
// CommentValidationSchema
const CommentValidationSchema = BaseCommentValidationSchema;
// UpdateCommentValidationSchema
const UpdateCommentValidationSchema = z.object({
    commentId: UUIDValidationSchema,
    createdBy: UUIDValidationSchema,
    body: z
        .string()
        .max(65535, 'Body must be 65535 characters or fewer')
        .optional(),
    attachments: z.array(UUIDValidationSchema).optional(),
    workshopId: UUIDValidationSchema.optional(),
    coordinates: z.array(z.number()).length(2).optional()
});
// UpdateReadStatusValidationSchema
const UpdateReadStatusValidationSchema = z.object({
    commentId: UUIDValidationSchema,
    userId: UUIDValidationSchema
});
export { CommentValidationSchema, UpdateCommentValidationSchema, UpdateReadStatusValidationSchema };
//# sourceMappingURL=comment.js.map